export default "__VITE_ASSET__BGLIvJ4l__"